<template>
  <DialogEx :options="dialogOptions" :title="fileName">
    <div style="width:100%;height:70vh;background:#fff;">
      <iframe
        v-if="previewUrl"
        :src="previewUrl"
        frameborder="0"
        style="width:100%;height:100%;border:none;"
      ></iframe>
    </div>
  </DialogEx>
</template>

<script>
import sha from '../../scripts/sha.js'
import Cookie from '../../scripts/cookie.js'
export default {
  name: 'FilePreviewDialog',
  props: {
    // 可覆盖下载接口基础地址；不传则按 domain cookie 在 apiCustomerUrl / apiBaseUrl 之间选择
    baseUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogOptions: { visible: false, size: 'large', showFooter: false },
      fileName: '',
      previewUrl: '',
    }
  },
  methods: {
    // fileName: 文件名称（含扩展名）；fileUrl: 后端存储地址（AttachmentUrl / CertFileUrl 等）
    open(fileName, fileUrl) {
      if (!fileUrl) {
        this.$message.warning('该记录未上传附件')
        return
      }
      this.fileName = fileName || fileUrl || ''
      var lower = (fileName || '').toLowerCase()
      var base = this.buildUrl(fileName, fileUrl)
      // Office 文档浏览器无法原生内联，走微软 Office Online 预览（需文件 URL 公网可达）
      if (/\.(doc|docx|xls|xlsx|ppt|pptx)$/.test(lower)) {
        this.previewUrl =
          'https://view.officeapps.live.com/op/view.aspx?src=' +
          encodeURIComponent(base)
      } else {
        // PDF / 图片 / txt 等浏览器可内联渲染的直接 iframe
        this.previewUrl = base
      }
      this.dialogOptions.visible = true
    },
    close() {
      this.previewUrl = ''
      this.dialogOptions.visible = false
    },
    buildUrl(fileName, fileUrl) {
      var domain = Cookie.get(Cookie.domain)
      var base = this.baseUrl || (domain ? window.AppConfig.apiCustomerUrl : window.AppConfig.apiBaseUrl)
      return (
        base +
        'omsapi/files/download?file=' +
        encodeURIComponent(fileName || '') +
        '&url=' +
        encodeURIComponent(fileUrl) +
        '&token=' +
        sha.getToken() +
        '&inline=1'
      )
    },
  },
}
</script>

<style></style>
